export default __webpack_public_path__ + "static/media/SG-DarkBlue-0003.87383a94.png";